import React from "react";
import { ContinentRegionProvider } from "../../context/ContinentRegionContext";

import Dashboard from "./Dashboard";
import Screen from "../../layout/Screen";
import Overview from "./manage/Overview";
import AddRegion from "./manage/AddRegion";
import EditRegion from "./manage/EditRegion";
import SingleRegionStats from "./manage/SingleRegionStats";

import { getCurrentRegion } from "../../lib/sysNavigation/SysNavigation";

export const Regions = () => {
  return (
    
      <Dashboard />
    
  );
};

export const RegionOverview = () => {
  return (
    <ContinentRegionProvider>
      <Overview />
    </ContinentRegionProvider>
  );
};

export const AddRegionComp = () => {
  return (
    <ContinentRegionProvider>
      <AddRegion />
    </ContinentRegionProvider>
  );
};

export const EditRegionComp = () => {
  return (
    <ContinentRegionProvider>
      <Screen title={getRegionName()}><EditRegion /></Screen>
    </ContinentRegionProvider>
  );
};

export const SingleRegionDashboard = () => {
  return (
    <ContinentRegionProvider>
      <Screen title={getRegionName()}><SingleRegionStats /></Screen>
    </ContinentRegionProvider>
  );
};

const getRegionName = () => {
  let regionName = "Region";
  if (getCurrentRegion().length > 0) regionName = getCurrentRegion()[0].name;
  return regionName;
};
